import {
  HTTP_REJECTAPPROVE_FETCHING,
  HTTP_REJECTAPPROVE_SUCCESS,
  HTTP_REJECTAPPROVE_FAILED,
  server,
  OK,
  YES,
} from "./../../Constants";
import { httpClient } from "./../../utils/HttpClient";

//Update Special
export const setStaterejectApproveByIdToFetching = () => ({
  type: HTTP_REJECTAPPROVE_FETCHING,
});

export const setStaterejectApproveByIdToSuccess = (payload) => ({
  type: HTTP_REJECTAPPROVE_SUCCESS,
  payload,
});

export const setStaterejectApproveByIdToFailed = (payload) => ({
  type: HTTP_REJECTAPPROVE_FAILED,
});

// export const updateBudgetOById = (budgetoid, memid, item) => {
export const rejectApproveById = (id, memid) => {
  return async (dispatch) => {
    dispatch(setStaterejectApproveByIdToFetching());
    try {
      await httpClient.put(`${server.REJECTAPPROVE_URL}/${id}/${memid}`);
      dispatch(setStaterejectApproveByIdToSuccess("success"));
    } catch (error) {
      dispatch(setStaterejectApproveByIdToFailed());
    }
  };
};
